import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import dompurify from 'dompurify'
import { AvatarCompat } from 'components/shared/AvatarCompat'
import _isEmpty from 'lodash/isEmpty'

import { botUser } from 'app/modules/user/selectors'
import { CtaTypes } from 'app/modules/playbook/constants'
import { getOrgName, selectedWidgetFont, getOrgShowBranding } from 'app/modules/embed/selectors'
import DefaultBotAvatar from '../DefaultBotAvatar'
import { FontFamilies } from '../constants'

import './style.styl'

const WelcomeMessageFooter = ({ showBranding = true }) => (
  <div className="welcome-message-preview--footer">
    { showBranding && <p className="welcome-message-preview--poweredby">Chat ⚡️ by <span className="welcome-message-preview-powered-by-drift">Drift</span></p> }
    { showBranding && <span className="welcome-message-preview--privacy-spacer">|</span> }
    <span className="welcome-message-preview--privacy-policy">
      Privacy Policy
    </span>
  </div>
)

const ButtonCallToAction = ({ ctaCopy, backgroundColorStyle }) => (
  <div className="welcome-message-preview--link-container">
    <div className="welcome-message-preview--ctaButton" style={backgroundColorStyle}>
      {ctaCopy || 'Chat With Us'}
    </div>
  </div>
)

const ChatCallToAction = ({ userName = null }) => (
  <div className="welcome-message-preview--composer-container">
    <div className="welcome-message-preview--composer">
      {`Reply to ${userName || 'Agent'}`}
    </div>
  </div>
)

class WelcomeMessagePreview extends PureComponent {
  render() {
    const { message, backgroundColor, users, orgName, fontFamily, callToAction, showBranding } = this.props
    if (!users.get(0)) {
      return null
    }

    const backgroundColorStyle = {
      backgroundColor: `#${backgroundColor}`
    }

    const hasChatCta = callToAction.type === CtaTypes.CHAT
    const hasButtonCta = callToAction.type === CtaTypes.URL || callToAction.type === CtaTypes.MEETING

    const isDefaultBotAvatar = users.getIn([0, 'bot']) && users.getIn([0, 'avatarUrl']) === null

    return (
      <div className="welcome-message-preview--container" style={{ fontFamily: FontFamilies[fontFamily] }}>
        <div className="welcome-message-preview--top-line" style={backgroundColorStyle}/>
        <div className="welcome-message-preview--content">
          <div className="welcome-message-preview--header">
            <div className="welcome-message-preview--header-content">
              <div className="welcome-message-preview--avatar-container">
                { isDefaultBotAvatar && <DefaultBotAvatar backgroundColor={backgroundColor}/> }
                { !isDefaultBotAvatar && <AvatarCompat size="small" user={users.get(0)}/>}
              </div>
              <span className="welcome-message-preview--user-name">
                {`${users.getIn([0, 'name']) || 'Agent'} from ${orgName}`}
              </span>
            </div>
          </div>
          <div className="welcome-message-preview--body" dangerouslySetInnerHTML={{ __html: dompurify.sanitize(message)}}/>
        </div>
        { hasChatCta && <ChatCallToAction userName={users.getIn([0, 'name'])}/> }
        { hasButtonCta && <ButtonCallToAction ctaCopy={callToAction.copy} backgroundColorStyle={backgroundColorStyle}/> }
        <WelcomeMessageFooter showBranding={showBranding}/>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  botUser: botUser(state),
  orgName: getOrgName(state),
  fontFamily: selectedWidgetFont(state),
  showBranding: getOrgShowBranding(state)
})

export default connect(mapStateToProps)(WelcomeMessagePreview)


// WEBPACK FOOTER //
// ./src/scripts/components/shared/PlaybookPreviews/WelcomeMessage/welcomeMessage.js